module.exports = __webpack_public_path__ + "img/1.12.2_Russian_road_sign.3a88f084.svg";